// extracted by mini-css-extract-plugin
export default {"container":"answer-row_container__bPMmb","row-field":"answer-row_row-field__mmhmd","list-header":"answer-row_list-header__VG6Ct","notOffer":"answer-row_notOffer__PN3VR"};